<section class="content">
  <app-supplier-header [imgCtaDefault]="userData"></app-supplier-header>
  <app-providers-cards [providerImg]="userData"></app-providers-cards>
  <app-supplier-contact [providerData]="userData"></app-supplier-contact>
  <app-providers-commits *ngIf="integracionUp"></app-providers-commits>
</section>